import { GasConsumptionData } from 'src/models/GasConsumption'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getDailyConsumptions
 */

export type DailyParams = {
  userId: number
  fromDate: string // YYYY-MM-DD
  toDate: string // YYYY-MM-DD
}

export const dailyDateFormat = 'YYYY-MM-DD'

export const getDailyConsumptions = async ({ userId, ...rest }: DailyParams) => {
  return await get<GasConsumptionData>(`/v1/users/${userId}/gasConsumptions/daily`, rest)
}

/**
 * getHourlyConsumptions
 */

export type HourlyParams = {
  userId: number
  fromDate: string // YYYY-MM-DD HH:mm:ss
  toDate: string // YYYY-MM-DD HH:mm:ss
}

export const hourlyDateFormat = 'YYYY-MM-DD HH:mm:ss'

export const getHourlyConsumptions = async ({ userId, ...rest }: HourlyParams) => {
  return await get<GasConsumptionData>(`/v1/users/${userId}/gasConsumptions/hourly`, rest)
}

/**
 * getMonthlyConsumptions
 */

export type MonthlyParams = {
  userId: number
  fromDate: string // YYYY-MM
  toDate: string // YYYY-MM
}

export const monthlyDateFormat = 'YYYY-MM'

export const getMonthlyConsumptions = async ({ userId, ...rest }: MonthlyParams) => {
  return await get<GasConsumptionData>(`/v1/users/${userId}/gasConsumptions/monthly`, rest)
}
